import React, { useState } from "react";
import axios from "axios";
import Style from "../Style/CourseMoreDisk.module.scss";

const CourseMoreDisk = () => {
  const [formData, setFormData] = useState({
    skill_detail_id: "",
    description: "",
  });
  const [message, setMessage] = useState("");
  const baseURL = process.env.REACT_APP_BASE_URL || "http://localhost:5000";
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${baseURL}/api/course_detail`,
        formData
      );
      setMessage(response.data.message);
      setFormData({ skill_detail_id: "", description: "" });
    } catch (error) {
      console.error(error);
      setMessage(
        error.response?.data?.error || "Error submitting course detail"
      );
    }
  };
  return (
    <div className={Style.CourseMoreDiskAdd}>
      <div className={Style.wrapper}>
        <div className={Style.CourseMoreDiskAlign}>
          <h2>Add Course Detail</h2>
        </div>
        <div className={Style.CourseMoreDiskForm}>
          <form onSubmit={handleSubmit}>
            <div className={Style.CourseMoreDiskInput}>
              <input
                type="number"
                name="skill_detail_id"
                value={formData.skill_detail_id}
                onChange={handleChange}
                placeholder="Skill Detail ID"
              />
            </div>

            <div className={Style.CourseMoreDiskInput}>
              <textarea
                name="description"
                value={formData.description}
                onChange={handleChange}
                rows={15}
                cols={60}
                placeholder="Description"
              />
            </div>

            <button type="submit">Add Course Detail</button>
          </form>

          {message && <p>{message}</p>}
        </div>
      </div>
    </div>
  );
};

export default CourseMoreDisk;
